import React, { useMemo, useState } from "react";
import {
  Container,
  Header,
  Formula,
  InputsGrid,
  Field,
  Label,
  Input,
  ResultsGrid,
  ResultCard,
  ResultLabel,
  ResultValue,
  Notice,
  Actions,
  ResetButton,
} from "./styles";

const DUBOIS_FACTOR = 0.007184;

function parsePositiveNumber(value) {
  const normalized = String(value).replace(",", ".").trim();

  if (!normalized || !/^\d+(?:\.\d+)?$/.test(normalized)) {
    return null;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function formatSquareMeters(value) {
  return `${value.toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  })} m²`;
}

export default function SuperficieCorporal() {
  const [peso, setPeso] = useState("");
  const [altura, setAltura] = useState("");

  const result = useMemo(() => {
    const pesoKg = parsePositiveNumber(peso);
    const alturaCm = parsePositiveNumber(altura);
    const hasAnyValue = peso.trim() || altura.trim();

    if (!hasAnyValue) {
      return {
        value: "--",
        message: "Informe peso e altura para calcular a superfície corporal.",
      };
    }

    if (pesoKg === null || alturaCm === null) {
      return {
        value: "--",
        message: "Informe peso e altura maiores que zero, usando apenas valores numéricos.",
      };
    }

    const superficieCorporal =
      DUBOIS_FACTOR * Math.pow(pesoKg, 0.425) * Math.pow(alturaCm, 0.725);

    return {
      value: formatSquareMeters(superficieCorporal),
      message: "Resultado estimado pela fórmula de Du Bois e Du Bois.",
    };
  }, [peso, altura]);

  function limparCampos() {
    setPeso("");
    setAltura("");
  }

  return (
    <Container>
      <Header>Cálculo de Superfície Corporal</Header>
      <Formula>
        Du Bois: SC (m²) = 0,007184 × peso (kg)<sup>0,425</sup> × altura (cm)<sup>0,725</sup>
      </Formula>

      <InputsGrid>
        <Field>
          <Label htmlFor="peso">Peso (kg)</Label>
          <Input
            id="peso"
            type="text"
            inputMode="decimal"
            autoFocus
            value={peso}
            onChange={(event) => setPeso(event.target.value)}
            placeholder="Ex.: 70,0"
          />
        </Field>

        <Field>
          <Label htmlFor="altura">Altura (cm)</Label>
          <Input
            id="altura"
            type="text"
            inputMode="decimal"
            value={altura}
            onChange={(event) => setAltura(event.target.value)}
            placeholder="Ex.: 170"
          />
        </Field>
      </InputsGrid>

      <ResultsGrid>
        <ResultCard>
          <ResultLabel>Superfície corporal estimada</ResultLabel>
          <ResultValue aria-live="polite">{result.value}</ResultValue>
        </ResultCard>
      </ResultsGrid>

      <Notice>{result.message} Use o resultado conforme o protocolo do serviço; ele não substitui avaliação clínica.</Notice>

      <Actions>
        <ResetButton type="button" onClick={limparCampos}>
          Limpar campos
        </ResetButton>
      </Actions>
    </Container>
  );
}
